/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-17 12:30:39
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import { prettyText, checkHasSpecialCharacters } from 'src/helpers';

/**
 * Build initial data for one merge value
 *
 * @param  {Object} mergeValuesOption merge value from API
 *
 * @return {Object} initialValue
 */
export const buildInitialStopWordsValues = (stopWordsData: Array<string>) => {
  const stopWords = stopWordsData.map(item => ({ value: item, isNew: false }));
  return { stopWords };
};

/**
 * Build data for one merge value
 *
 * @param  {Object} mergeValues merge value from API
 *
 * @return {Object} initialValue
 */
export const buildStopWordsValues = (stopWords: Array<{ value: string, isNew: boolean }>) => {
  const result = stopWords.map(item => item.value);

  return result;
};

/**
 * Check validate stopWord
 *
 * @param  {string} stopWord
 *
 * @return {string} checked result
 *
 */
export const checkValidateStopWord = (stopWord, stopWords) => {
  let value = stopWord.trim().toLowerCase();

  if (value) {
    if (value.length > 128) {
      return {
        error: 'AdminHTML.StopWords.Validate.invalid_StopWords_Length'
      };
    }
    if (/[>,=]/.test(value)) {
      return {
        error: 'AdminHTML.StopWords.Validate.invalid_StopWords_SpecialCharacter01'
      };
    }
    value = prettyText(value);

    let checkSpecialCharactersValue = checkHasSpecialCharacters(value);
    if (_.isEmpty(value) || checkSpecialCharactersValue) {
      return {
        error: `AdminHTML.StopWords.Validate.invalid_StopWords_SpecialCharacter02`
      };
    }

    const found = _.find(stopWords, item => item.value === value);
    if (_.isEmpty(found)) {
      return {
        stopWord: value,
        error: ''
      };
    } else {
      return {
        error: 'AdminHTML.StopWords.Validate.invalid_StopWords_Exist'
      };
    }
  }

  return {};
};
